<eazly-header [myappeaz]="myappeaz"></eazly-header>


<div class="main container">
  <eazly-appeaz-dashboard *ngIf="ready | async" [myappeaz]="myappeaz"></eazly-appeaz-dashboard>
</div>
